import Layout from "../../../components/Layout";
import FormPostFunc from "../Formularios/formPostUser";

export default function PostAlunoAnamnese() {
  return Layout(FormPostFunc, "Anamnese");
}
